import axios from 'axios'
import qs from 'qs'
import { message } from 'antd'
import 'antd/dist/antd.css';
import { remove } from './localstorage';

// axios.defaults.baseURL = 'http://192.168.2.9:8095/'
axios.defaults.baseURL = "http://lingke.ylly1001.com/";
axios.defaults.timeout = 100000;
axios.defaults.withCredentials = true;

const path = "http://lingke.ylly1001.com/";

axios.interceptors.response.use(
    (res)=> {
    //   console.log(res);
      return res;
    },
    (err)=> {
      // 对响应错误做点什么

      // console.log(err.response.status)
      // console.log(err.response)
      if(err.response.status === 401){
        remove('token');
        remove('info');
        message.info('请重新登录！');
        window.location.hash = '/'
      }
      
      return Promise.reject(err);
    }
);

let token = JSON.parse(localStorage.getItem('token'));

 let get = function(url,params,loading){
     return new Promise((resolve,reject)=>{
         axios
         .get(url,{params:params},{
            headers:{
               "withCredentials":false,
               "token":token,
            },
        })
         .then(res=>{
             resolve(res);
         })
         .catch(err =>{
             reject(err)
         })


     })
 }

 let post = function(url,data){
     return new Promise((resolve,reject)=>{
         axios
         .post(url,qs.stringify(data),{
            headers:{
               "token":token,
            },
        })
         .then(res =>{
            //  console.log(res);
             resolve(res)
         })
         .catch(err =>{
             reject(err)
         })
     })
 }

 let formData = function(url,data){
    return new Promise((resolve,reject)=>{
        axios
        .post(url,data,{
            headers:{
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(res =>{
            resolve(res)
        })
        .catch(err =>{
            reject(err)
        })
    })
  }

const http = { get, post , formData , path }

 export default http;